/**
 * Generic column ids shared across multiple tables (e.g. an actions column). Part of the
 * `ColumnNamingId` union in `~/components/planning/ProductTable/utils/columnUtils` so these
 * don't need a per-table enum.
 */
export enum CommonColumn {
  Actions = "actions",
}
